import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import { stringifyQuery, parseQuery } from '@/utils/query'
import JessibucaPlayer from '@/components/JessibucaPlayer'

Vue.use(Router)

/* Layout */
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // {path:'/:pathMatch(.*)*',component:''},
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },

  {
    path: '/mobilePage',
    component: () => import('@/views/mobilePage'),
    hidden: true,
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    redirect: '/welcome/welcome',
    hidden: true,
  },
  {
    path: '/error',
    component: () => import('@/views/error'),
    hidden: true,
  },
  {
    path: '/welcome',
    component: Layout,
    hidden: true,
    // meta: { title: '首页' },
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: () => import('@/views/welcome'),
        meta: { title: '首页' },
      },
    ],
  },
  {
    name: 'videoPlay',
    path: '/videoPlay',
    meta: { title: '播放视频', icon: '', noCache: true },
    component: () => import('@/views/videoPlay'),
    hidden: true,
  },
  {
    path: '/videoTutorials',
    meta: { title: '视频教程', icon: '', noCache: true },
    component: () => import('@/views/videoTutorials'),
    hidden: true,
  },
  {
    path: '/paymentReminder',
    meta: { title: '催费单', icon: '', noCache: true },
    component: () => import('@/views/paymentReminder'),
    hidden: true,
  },
  {
    path: '/deliveryNote',
    meta: { title: '交割单', icon: '', noCache: true },
    component: () => import('@/views/deliveryNote'),
    hidden: true,
  },
  {
    path: '/contractPaymentNotice',
    meta: { title: '缴费通知单', icon: '', noCache: true },
    component: () => import('@/views/contractPaymentNotice'),
    hidden: true,
  },
  {
    path: '/RenovationPermit',
    meta: { title: '装修许可证', icon: '', noCache: true },
    component: () => import('@/views/RenovationPermit'),
    hidden: true,
  },
  {
    path: '/batchQRCodePrinting',
    meta: { title: '二维码打印', icon: '', noCache: true },
    component: () => import('@/views/batchQRCodePrinting'),
    hidden: true,
  },
  {
    path: '/WorkOrderLocationQRCode',
    meta: { title: '二维码打印', icon: '', noCache: true },
    component: () => import('@/views/WorkOrderLocationQRCode'),
    hidden: true,
  },
  {
    path: '/play/wasm/:url',
    name: 'JessibucaPlayer',
    component: JessibucaPlayer,
  },
  // {
  //   path: '/dataScreen',
  //   component: () => import('@/views/dataScreen/dataScreen'),
  //   hidden: true,
  // },
  // {
  //   path: '/amount',
  //   meta: { title: '数据大屏-收款情况', icon: '', noCache: true },
  //   component: () => import('@/views/dataScreen/Amount'),
  //   hidden: true,
  // },
  // {
  //   path: '/inspection',
  //   meta: { title: '数据大屏-巡检情况', icon: '', noCache: true },
  //   component: () => import('@/views/dataScreen/Inspection'),
  //   hidden: true,
  // },
  // {
  //   path: '/patrol',
  //   meta: { title: '数据大屏-巡更情况', icon: '', noCache: true },
  //   component: () => import('@/views/dataScreen/Patrol'),
  //   hidden: true,
  // },

  // {
  //   path: '/permission',
  //   component: Layout,
  //   redirect: '/permission/PrimaryMenu',
  //   meta: { title: '权限管理', icon: '', noCache: true },
  //   children: [
  //     {
  //       path: 'PrimaryMenu',
  //       name: 'PrimaryMenu',
  //       component: () => import('@/views/permission/PrimaryMenu'),
  //       meta: { title: '菜单管理', icon: '', noCache: true },
  //     },
  //     {
  //       path: 'SecondaryMenu',
  //       name: 'SecondaryMenu',
  //       component: () => import('@/views/permission/SecondaryMenu'),
  //       meta: { title: '子菜单管理', icon: '', noCache: true },
  //     },
  //     {
  //       path: 'PermissionItem',
  //       name: 'PermissionItem',
  //       component: () => import('@/views/permission/PermissionItem'),
  //       meta: { title: '权限项管理', icon: '', noCache: true },
  //     },
  //   ],
  // },
  // {
  //   path: '/merchant',
  //   component: Layout,
  //   redirect: '/merchant/serviceCatalog',
  //   meta: { title: '商户管理', icon: '', noCache: true },
  //   children: [
  //     {
  //       path: 'serviceCatalog',
  //       name: 'serviceCatalog',
  //       component: () => import('@/views/merchant/serviceCatalog'),
  //       meta: { title: '服务分类', icon: '', noCache: true },
  //     },
  //     {
  //       path: 'merchantAudit',
  //       name: 'merchantAudit',
  //       component: () => import('@/views/merchant/merchantAudit'),
  //       meta: { title: '商户审核', icon: '', noCache: true },
  //     },
  //   ],
  // },
  // {
  //   path: '/tenantManagement',
  //   component: Layout,
  //   redirect: '/tenantManagement/dataSource',
  //   meta: { title: '租户管理', icon: '', noCache: true },
  //   children: [
  //     {
  //       path: 'dataSource',
  //       name: 'dataSource',
  //       component: () => import('@/views/tenantManagement/dataSource'),
  //       meta: { title: '数据源管理', icon: '', noCache: true },
  //     },
  //     {
  //       path: 'propertyManagement',
  //       name: 'propertyManagement',
  //       component: () => import('@/views/tenantManagement/propertyManagement'),
  //       meta: { title: '物业管理', icon: '', noCache: true },
  //     },
  //   ],
  // },
]

// {
//   path: '/business',
//   component: Layout,
//   children: [
//     {
//       path: 'business',
//       name: 'Business',
//       component: () => import('@/views/business'),
//       meta: { title: '业务办理', icon: 'business', noCache: true },
//     },
//   ],
// },

// {
//   path: '/auxiliaryConfig',
//   component: Layout,
//   redirect: '/auxiliaryConfig/payConfig',
//   meta: { title: '辅助配置', icon: 'auxiliaryConfig', noCache: true },
//   children: [
//     {
//       path: 'payConfig',
//       name: 'PayConfig',
//       component: () => import('@/views/auxiliaryConfig/payConfig'),
//       meta: { title: '支付配置', icon: '', noCache: true },
//     },
//     {
//       path: 'admin',
//       name: 'Admin',
//       component: () => import('@/views/auxiliaryConfig/admin'),
//       meta: { title: '后台配置', icon: '', noCache: true },
//     },
//     {
//       path: 'messageConfig',
//       name: 'MessageConfig',
//       component: () => import('@/views/auxiliaryConfig/messageConfig'),
//       meta: { title: '短信配置', icon: '', noCache: true },
//     },
//     {
//       path: 'operationLog',
//       name: 'OperationLog',
//       component: () => import('@/views/auxiliaryConfig/operationLog/index'),
//       meta: { title: '操作日志', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/workManage',
//   component: Layout,
//   redirect: '/workManage/departmentManage',
//   meta: { title: '办公管理', icon: 'workManage', noCache: true },
//   children: [
//     {
//       path: 'departmentManage',
//       name: 'DepartmentManage',
//       component: () => import('@/views/workManage/departmentManage'),
//       meta: { title: '部门管理', icon: '', noCache: true },
//     },
//     {
//       path: 'rolesManage',
//       name: 'RolesManage',
//       component: () => import('@/views/workManage/rolesManage'),
//       meta: { title: '角色管理', icon: '', noCache: true },
//     },
//     {
//       path: 'memberManage',
//       name: 'MemberManage',
//       component: () => import('@/views/workManage/memberManage'),
//       meta: { title: '人员管理', icon: '', noCache: true },
//     },
//     {
//       path: 'community',
//       name: 'Community',
//       component: () => import('@/views/workManage/community'),
//       meta: { title: '项目管理', icon: '', noCache: true },
//     },
//     {
//       path: 'householdCheck',
//       name: 'HouseholdCheck',
//       component: () => import('@/views/workManage/householdCheck'),
//       meta: { title: '住户认证', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/attendanceManage',
//   component: Layout,
//   redirect: '/attendanceManage/attendRule',
//   meta: { title: '考勤规则', icon: 'attendanceManage', noCache: true },
//   children: [
//     {
//       path: 'attendRule',
//       name: 'AttendRule',
//       component: () => import('@/views/attendanceManage/attendRule'),
//       meta: { title: '考勤规则', icon: '', noCache: true },
//     },
//     {
//       path: 'attendLog',
//       name: 'AttendLog',
//       component: () => import('@/views/attendanceManage/attendLog'),
//       meta: { title: '考勤记录', icon: '', noCache: true },
//     },
//     {
//       path: 'rosterTable',
//       name: 'RosterTable',
//       component: () => import('@/views/attendanceManage/rosterTable'),
//       meta: { title: '考勤统计', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/materialManage',
//   component: Layout,
//   redirect: '/materialManage/goodsType',
//   meta: { title: '物资管理', icon: 'materialManage', noCache: true },
//   children: [
//     {
//       path: 'goodsType',
//       name: 'GoodsType',
//       component: () => import('@/views/materialManage/goodsType'),
//       meta: { title: '物资类目', icon: '', noCache: true },
//     },
//     {
//       path: 'materialList',
//       name: 'MaterialList',
//       component: () => import('@/views/materialManage/materialList'),
//       meta: { title: '物资列表', icon: '', noCache: true },
//     },
//     {
//       path: 'warehouse',
//       name: 'WareHouse',
//       component: () => import('@/views/materialManage/warehouse'),
//       meta: { title: '仓库设置', icon: '', noCache: true },
//     },
//     {
//       path: 'goodsSave',
//       name: 'GoodsSave',
//       component: () => import('@/views/materialManage/goodsSave'),
//       meta: { title: '物资库存', icon: '', noCache: true },
//     },
//     {
//       path: 'libraryDetail',
//       name: 'LibraryDetail',
//       component: () => import('@/views/materialManage/libraryDetail'),
//       meta: { title: '出入库明细', icon: '', noCache: true },
//     },
//     {
//       path: 'getGoods',
//       name: 'GetGoods',
//       component: () => import('@/views/materialManage/getGoods'),
//       meta: { title: '物资申领', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/dataManage',
//   component: Layout,
//   redirect: '/dataManage/community',
//   meta: { title: '房产管理', icon: 'dataManage', noCache: true },
//   children: [
//     {
//       path: 'building',
//       name: 'Building',
//       component: () => import('@/views/dataManage/building'),
//       meta: { title: '楼栋管理', icon: '', noCache: true },
//     },
//     {
//       path: 'buildingUnit',
//       name: 'BuildingUnit',
//       component: () => import('@/views/dataManage/buildingUnit'),
//       meta: { title: '单元管理', icon: '', noCache: true },
//     },
//     {
//       path: 'buildingFloor',
//       name: 'BuildingFloor',
//       component: () => import('@/views/dataManage/buildingFloor'),
//       meta: { title: '楼层管理', icon: '', noCache: true },
//     },
//     {
//       path: 'house',
//       name: 'House',
//       component: () => import('@/views/dataManage/house'),
//       meta: { title: '房屋管理', icon: '', noCache: true },
//     },
//     {
//       path: 'householdManage',
//       name: 'HouseholdManage',
//       component: () => import('@/views/dataManage/householdManage'),
//       meta: { title: '住户管理', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/parkManage',
//   component: Layout,
//   redirect: '/parkManage/parkManage',
//   meta: { title: '车位管理', icon: 'parkManage', noCache: true },
//   children: [
//     {
//       path: 'parkManage',
//       name: 'ParkManage',
//       component: () => import('@/views/parkManage/parkManage'),
//       meta: { title: '车场管理', icon: '', noCache: true },
//     },
//     {
//       path: 'parkSpaceType',
//       name: 'ParkSpaceType',
//       component: () => import('@/views/parkManage/parkSpaceType'),
//       meta: { title: '车位类型管理', icon: '', noCache: true },
//     },
//     {
//       path: 'parkPlace',
//       name: 'ParkPlace',
//       component: () => import('@/views/parkManage/parkPlace'),
//       meta: { title: '车位管理', icon: '', noCache: true },
//     },
//     {
//       path: 'carManage',
//       name: 'CarManage',
//       component: () => import('@/views/parkManage/carManage'),
//       meta: { title: '车辆管理', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/finance',
//   component: Layout,
//   redirect: '/finance/paymentConfig',
//   meta: { title: '财务管理', icon: 'finance', noCache: true },
//   children: [
//     {
//       path: 'paymentConfig',
//       name: 'PaymentConfig',
//       component: () => import('@/views/finance/paymentConfig'),
//       meta: { title: '收费科目', icon: '', noCache: true },
//     },
//     {
//       path: 'paymentType',
//       name: 'PaymentType',
//       component: () => import('@/views/finance/paymentType'),
//       meta: { title: '收款方式', icon: '', noCache: true },
//     },
//     {
//       path: 'paymentStandard',
//       name: 'PaymentStandard',
//       component: () => import('@/views/finance/paymentStandard'),
//       meta: { title: '收费标准', icon: '', noCache: true },
//     },
//     {
//       path: 'reportForm',
//       name: 'ReportForm',
//       component: () => import('@/views/finance/reportForm'),
//       meta: { title: '财务报表', icon: '', noCache: true },
//     },
//     {
//       path: 'horseUnPayOrder',
//       name: 'HorseUnPayOrder',
//       component: () => import('@/views/finance/horseUnPayOrder'),
//       meta: { title: '房屋未缴', icon: '', noCache: true },
//     },
//     {
//       path: 'parkSpaceUnPayOrder',
//       name: 'ParkSpaceUnPayOrder',
//       component: () => import('@/views/finance/parkSpaceUnPayOrder'),
//       meta: { title: '车位未缴', icon: '', noCache: true },
//     },
//     {
//       path: 'paymentLog',
//       name: 'PaymentLog',
//       component: () => import('@/views/finance/paymentLog'),
//       meta: { title: '收款记录', icon: '', noCache: true },
//     },
//     {
//       path: 'discount',
//       name: 'Discount',
//       component: () => import('@/views/finance/discount'),
//       meta: { title: '优惠记录', icon: '', noCache: true },
//     },
//     {
//       path: 'refundLog',
//       name: 'RefundLog',
//       component: () => import('@/views/finance/refundLog'),
//       meta: { title: '退款记录', icon: '', noCache: true },
//     },
//     {
//       path: 'refundAuditFlow',
//       name: 'RefundAuditFlow',
//       component: () => import('@/views/finance/refundAuditFlow'),
//       meta: { title: '退款审批流程', icon: '', noCache: true },
//     },
//     {
//       path: 'refundApproval',
//       name: 'RefundApproval',
//       component: () => import('@/views/finance/refundApproval'),
//       meta: { title: '退款审批', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/equipment',
//   component: Layout,
//   redirect: '/equipment/equipmentType',
//   meta: { title: '设备管理', icon: 'equipment', noCache: true },
//   children: [
//     {
//       path: 'systemManagement',
//       name: 'systemManagement',
//       component: () => import('@/views/equipment/systemManagement'),
//       meta: { title: '设备系统管理', icon: '', noCache: true },
//     },
//     {
//       path: 'bigCategory',
//       name: 'bigCategory',
//       component: () => import('@/views/equipment/bigCategory'),
//       meta: { title: '设备大类管理', icon: '', noCache: true },
//     },
//     {
//       path: 'smallCategory',
//       name: 'smallCategory',
//       component: () => import('@/views/equipment/smallCategory'),
//       meta: { title: '设备小类管理', icon: '', noCache: true },
//     },
//     {
//       path: 'equipmentType',
//       name: 'EquipmentType',
//       component: () => import('@/views/equipment/equipmentType'),
//       meta: { title: '设备列表', icon: '', noCache: true },
//     },
//     {
//       path: 'patrolItem',
//       name: 'PatrolItem',
//       component: () => import('@/views/equipment/patrolItem'),
//       meta: { title: '巡检项目', icon: '', noCache: true },
//     },
//     {
//       path: 'patrolLog',
//       name: 'PatrolLog',
//       component: () => import('@/views/equipment/patrolLog'),
//       meta: { title: '巡检记录', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/electronicPatrol',
//   component: Layout,
//   redirect: '/electronicPatrol/electronicPlace',
//   meta: { title: '电子巡更', icon: 'electronicPatrol', noCache: true },
//   children: [
//     {
//       path: 'electronicPlace',
//       name: 'ElectronicPlace',
//       component: () => import('@/views/electronicPatrol/electronicPlace'),
//       meta: { title: '巡更地点', icon: '', noCache: true },
//     },
//     {
//       path: 'electronicRoute',
//       name: 'ElectronicRoute',
//       component: () => import('@/views/electronicPatrol/electronicRoute'),
//       meta: { title: '巡更路线', icon: '', noCache: true },
//     },
//     {
//       path: 'patrolStatistics',
//       name: 'patrolStatistics',
//       component: () => import('@/views/electronicPatrol/patrolStatistics'),
//       meta: { title: '巡更统计', icon: '', noCache: true },
//     },
//     {
//       path: 'electronicLog',
//       name: 'ElectronicLog',
//       component: () => import('@/views/electronicPatrol/electronicLog'),
//       meta: { title: '巡更记录', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/workOrder',
//   component: Layout,
//   redirect: '/workOrder/workOrderType',
//   meta: { title: '工单管理', icon: 'workOrder', noCache: true },
//   children: [
//     {
//       path: 'workOrderType',
//       name: 'WorkOrderType',
//       component: () => import('@/views/workOrder/workOrderType'),
//       meta: { title: '工单分类', icon: '', noCache: true },
//     },
//     {
//       path: 'workOrderLIst',
//       name: 'WorkOrderLIst',
//       component: () => import('@/views/workOrder/workOrderLIst'),
//       meta: { title: '工单列表', icon: '', noCache: true },
//     },
//     {
//       path: 'evaluate',
//       name: 'Evaluate',
//       component: () => import('@/views/workOrder/evaluate'),
//       meta: { title: '评价列表', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/contentManagement',
//   component: Layout,
//   redirect: '/contentManagement/contentCategory',
//   meta: { title: '内容管理', icon: 'contentManagement', noCache: true },
//   children: [
//     {
//       path: 'contentCategory',
//       name: 'contentCategory',
//       component: () => import('@/views/contentManagement/contentCategory'),
//       meta: { title: '内容分类', icon: '', noCache: true },
//     },
//     {
//       path: 'introduction',
//       name: 'introduction',
//       component: () => import('@/views/contentManagement/introduction'),
//       meta: { title: '物业介绍', icon: '', noCache: true },
//     },
//     {
//       path: 'propertyStyle',
//       name: 'propertyStyle',
//       component: () => import('@/views/contentManagement/propertyStyle'),
//       meta: { title: '物业风采', icon: '', noCache: true },
//     },
//     {
//       path: 'telephone',
//       name: 'telephone',
//       component: () => import('@/views/contentManagement/telephone'),
//       meta: { title: '便民电话', icon: '', noCache: true },
//     },
//     {
//       path: 'homeNotification',
//       name: 'homeNotification',
//       component: () => import('@/views/contentManagement/homeNotification'),
//       meta: { title: '首页通知', icon: '', noCache: true },
//     },

//     {
//       path: 'communityAnnouncement',
//       name: 'communityAnnouncement',
//       component: () => import('@/views/contentManagement/communityAnnouncement'),
//       meta: { title: '社区公告', icon: '', noCache: true },
//     },
//     {
//       path: 'announcement',
//       name: 'announcement',
//       component: () => import('@/views/contentManagement/announcement'),
//       meta: { title: '公司通知', icon: '', noCache: true },
//     },
//     {
//       path: 'poll',
//       name: 'poll',
//       component: () => import('@/views/contentManagement/poll'),
//       meta: { title: '问卷调查', icon: '', noCache: true },
//     },
//   ],
// },

// {
//   path: '/serviceCenter',
//   component: Layout,
//   children: [
//     {
//       path: 'serviceCenter',
//       name: 'ServiceCenter',
//       component: () => import('@/views/serviceCenter'),
//       meta: { title: '客服中心', icon: 'serviceCenter', noCache: true },
//     },
//   ],
// },

const createRouter = () =>
  new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    stringifyQuery, // 序列化query参数
    parseQuery, // 反序列化query参数
    routes: constantRoutes,
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
